import { render, staticRenderFns } from "./StaffLookup.vue?vue&type=template&id=3170c314&"
import script from "./StaffLookup.vue?vue&type=script&lang=js&"
export * from "./StaffLookup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports